export type LatLngLevel = {
    lat: number;
    lng: number;
    level?: number | null;
};

/** Parse a position from URL params, accepting legacy `alt` as floor level. */
export function parseLatLngLevelParam(raw: string): LatLngLevel {
    const pos = JSON.parse(raw) as { lat: number; lng: number; level?: number | null; alt?: number | null };

    return {
        lat: pos.lat,
        lng: pos.lng,
        level: pos.level ?? pos.alt ?? null,
    };
}
